<template>
<q-dialog class="dialog promote-dialog">
  <q-card class="promote-dialog__inner">
    <common-form :action="$route('mapgroup.map.replace', { mapGroup, map })">

      <q-card-section class="row items-center" :class="{'q-px-lg': $isDesktop}">
        <div class="heading-3 q-mr-sm">Kaart {{ map.title }} vervangen</div>
        <q-space />
        <icon-button icon="close" aria-label="Sluit dialoogvenster" size="sm" round v-close-popup />
      </q-card-section>
      <q-card-section class="dialog__messages" :class="$isMobile ? 'q-pb-none' : 'q-px-lg q-pt-none q-pb-sm'">
        <template v-if="ruleVersionIds.length && structuralElementIds.length">
          Met welke kaart wilt u de kaart {{ map.title }} bij de {{ ruleVersionIds.length }} geselecteerde
          richtlijnen en {{ structuralElementIds.length }} geselecteerde
          inrichtingselementen vervangen?
        </template>
        <template v-else-if="ruleVersionIds.length">
          Met welke kaart wilt u de kaart {{ map.title }} bij de {{ ruleVersionIds.length }} geselecteerde
          richtlijnen vervangen?
        </template>
        <template v-else-if="structuralElementIds.length">
          Met welke kaart wilt u de kaart {{ map.title }} bij de {{ structuralElementIds.length }} geselecteerde
          inrichtingselementen vervangen?
        </template>
        <template v-else-if="structuralElementsEnabled">
          Met welke kaart wilt u de kaart {{ map.title }} bij alle richtlijnen en inrichtingselmenten waaraan deze
          gekoppeld is vervangen?
        </template>
        <template v-else="structuralElementsEnabled">
          Met welke kaart wilt u de kaart {{ map.title }} bij alle richtlijnen waaraan deze gekoppeld is vervangen?
        </template>
      </q-card-section>
      <q-card-section class="dialog__form" :class="{'q-px-lg': $isDesktop}">
        <common-input
            v-model="searchQuery"
            @update:modelValue="searchMaps(searchQuery)"
            :loading="loadingMaps"
            label="Zoek een kaart"
            clearable />
        <q-list bordered separator>
          <q-item
              tag="label"
              v-for="map in maps.data"
              :key="map.id"
          >
            <q-item-section avatar>
              <q-radio v-model="form.otherMapId" :val="map.id"
                       :aria-label="`Vervang met ${map.title}`"
                       name="target_map_id" />
            </q-item-section>
            <q-item-section>
              <q-item-label>{{ map.title }}</q-item-label>
            </q-item-section>
          </q-item>
          <q-item v-if="maps?.last_page > 1" class="flex flex-center">
            <PaginationLinks :items="maps" @navigate="goToPage" />
          </q-item>
        </q-list>
        <input v-for="id in ruleVersionIds" type="hidden" name="rule_version_ids[]" :value="id" :key="id">
        <input v-for="id in structuralElementIds" type="hidden" name="structural_object_ids[]" :value="id" :key="id">
      </q-card-section>
      <q-card-actions :class="$isMobile ? 'q-pa-md' : 'q-px-lg q-py-md'">
        <accent-button
            label="Vervang"
            type="submit"
        />
        <flat-button
            label="Annuleren"
            v-close-popup
        />
      </q-card-actions>
    </common-form>
  </q-card>
</q-dialog>
</template>

<script>

import FlatButton from '../../../components/button/FlatButton.vue'

export default {
  components: { FlatButton },
  props: {
    ruleVersionIds: {
      type: Array,
      required: true,
    },
    structuralElementIds: {
      type: Array,
      required: true,
    },
    mapGroup: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    structuralElementsEnabled: {
      type: Boolean,
    },
  },
  data () {
    return {
      searchQuery: '',
      loadingMaps: false,
      maps: [],
      form: {
        otherMapId: null,
      },
      page: 1,
    }
  },
  methods: {
    searchMaps: _.debounce(async function (searchQuery) {
      if (searchQuery !== this.searchQuery) {
        return
      }
      this.goToPage(1)
    }, 500),
    async goToPage (page) {
      this.loadingMaps = true
      const { data } = await axios.get(this.$route('api.map.search'), {
        params: {
          excluded_id: this.map.id,
          query: this.searchQuery,
          page,
        },
      })
      this.maps = data
      this.loadingMaps = false
    },
  },
  mounted () {
    this.searchMaps('')
  },
}
</script>
